import { instance } from '@/shared/lib/clientAxios';

interface getSipConnectionInfoResponse {
  passowrd: string;
  username: string;
}
// sip register connection data get
export const getSipConnectionInfo = async (): Promise<getSipConnectionInfoResponse> => {
  const response = await instance.get('/v1/sip/connection-info');
  return response.data;
};

// SDK 클라이언트 키 발급
export const postSipClientKey = async () => {
  const response = await instance.post('/v1/sip/client/join');
  return response.data;
};

// SIP 정보 조회(username, password 발급)
export const getSdkSipConnectionInfo = async (number015: number) => {
  const response = await instance.post(`/v1/sip/client/connection-info/${number015}`);
  return response.data;
};

// 통화내역 조회
type pageDataType = {
  page: number;
  size: number;
};
export const getCallsHistory = async (pageData: pageDataType) => {
  const response = await instance.get('/v1/sip/calls', {
    params: pageData,
  });
  return response.data;
};

// InboundStatus 상태 확인 (ARS, 음성통화)
export const getInboundStatus = async () => {
  const response = await instance.get('/v1/inbound-status');
  return response.data;
};

// InboundStatus 상태 토글 (ARS, 음성통화)
export const putInboundStatus = async () => {
  const response = await instance.put('/v1/inbound-status');
  return response.data;
};
